import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import Loader from "../components/icons/Loader";
import axiosInstance from "../api/axiosInstance";

const TermsAndConditions = () => {
  const [terms, setTerms] = useState(null);
  const [loading, setLoading] = useState(true);

  const getTerms = async () => {
    setLoading(true);
    const res = await axiosInstance.get("/user/terms");
    setTerms(res.data?.terms?.content);
    setLoading(false);
  };

  useEffect(() => {
    getTerms();
  }, []);

  return (
    <div 
      style={{
        backgroundColor: "var(--inyc-primary)",
        color: "var(--inyc-primary-text-color)",
        height: "100vh",
        overflow: "auto",
        paddingBottom: "calc(env(safe-area-inset-bottom) + 2rem)"
      }}
    >
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%"
          }}
        >
          <Loader />
        </div>
      ) : (
        <div
          className="p-kit-32 max-w-[1500px] mx-auto ql-editor"
          dangerouslySetInnerHTML={{
            __html: terms,
          }}
        ></div>
      )}
    </div>
  );
};

export default TermsAndConditions;
